var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0538 35.0772C35.7297 35.0772 35.4188 35.2124 35.1896 35.4531C34.9604 35.6937 34.8316 36.0201 34.8316 36.3605C34.8316 36.7009 34.9604 37.0273 35.1896 37.2679C35.4188 37.5086 35.7297 37.6438 36.0538 37.6438H40.9426C41.2668 37.6438 41.5777 37.5086 41.8069 37.2679C42.0361 37.0273 42.1648 36.7009 42.1648 36.3605C42.1648 36.0201 42.0361 35.6937 41.8069 35.4531C41.5777 35.2124 41.2668 35.0772 40.9426 35.0772H36.0538ZM12.832 23.5274C12.832 21.8256 13.4759 20.1935 14.6219 18.9902C15.7679 17.7869 17.3223 17.1108 18.943 17.1108H40.9426C42.5634 17.1108 44.1177 17.7869 45.2638 18.9902C46.4098 20.1935 47.0536 21.8256 47.0536 23.5274V36.3605C47.0536 38.0623 46.4098 39.6944 45.2638 40.8977C44.1177 42.101 42.5634 42.7771 40.9426 42.7771H18.943C17.3223 42.7771 15.7679 42.101 14.6219 40.8977C13.4759 39.6944 12.832 38.0623 12.832 36.3605V23.5274ZM44.6092 24.8107V23.5274C44.6092 22.5063 44.2229 21.5271 43.5353 20.8051C42.8477 20.0831 41.9151 19.6775 40.9426 19.6775H18.943C17.9706 19.6775 17.038 20.0831 16.3504 20.8051C15.6627 21.5271 15.2764 22.5063 15.2764 23.5274V24.8107H44.6092ZM15.2764 27.3773V36.3605C15.2764 37.3816 15.6627 38.3608 16.3504 39.0828C17.038 39.8048 17.9706 40.2104 18.943 40.2104H40.9426C41.9151 40.2104 42.8477 39.8048 43.5353 39.0828C44.2229 38.3608 44.6092 37.3816 44.6092 36.3605V27.3773H15.2764Z",
    fill: "#626262",
    stroke: "#626262",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/paymentCard.ae8c01d82666cdcab3f545f1dcc2a51e.svg";
export { ForwardRef as ReactComponent };